// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeConstElements_container__1iKOh {
  padding-inline: 28px;
}
.ThemeConstElements_Badge__\\+9U02 {
  font-size: 14px;
  width: 26px;
  height: 25.16px;
  left: 1148px;
  top: 753px;
  border-radius: 50%;
  background: #573aa3;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.69);
}
/* @media all and (max-width: 300px) {
  .container {
    padding-inline: 15px;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeConstElements/ThemeConstElements.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;;;;GAIG","sourcesContent":[".container {\r\n  padding-inline: 28px;\r\n}\r\n.Badge {\r\n  font-size: 14px;\r\n  width: 26px;\r\n  height: 25.16px;\r\n  left: 1148px;\r\n  top: 753px;\r\n  border-radius: 50%;\r\n  background: #573aa3;\r\n  align-items: center;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.69);\r\n}\r\n/* @media all and (max-width: 300px) {\r\n  .container {\r\n    padding-inline: 15px;\r\n  }\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ThemeConstElements_container__1iKOh`,
	"Badge": `ThemeConstElements_Badge__+9U02`
};
export default ___CSS_LOADER_EXPORT___;
